import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import Quote from "../components/Quote"
import References from "../components/References"
import PageHead from "../components/PageHead"
import HubspotFormEmbed from "../components/HubspotEmbed"

export const BookPageTemplate = ({
  title,
  pointsTitle,
  points,
  quote,
  solutionsTitle,
  solutions,
}) => {
  return (
    <section className="book-a-demo-page">
      <div className="book-a-demo-head">
        <div className="spacing-l" style={{ marginTop: "4rem" }}>
          <h1 className="h2">{title}</h1>
          <p className="spacing-m">{pointsTitle}</p>
          <ul className=" spacing-xl">
            {points.map(({ title, description, icon }) => (
              <li key={title}>
                {/* <Icon icon={icon} style={{ minWidth: 40 }} /> */}
                {description}
              </li>
            ))}
          </ul>
          {solutionsTitle && (
            <h5 className="solutions-title">{solutionsTitle}</h5>
          )}
          {solutions && solutions.length && (
            <ul className="solutions-list">
              {solutions.map((solution) => (
                <li key={solution}>{solution}</li>
              ))}
            </ul>
          )}
        </div>
        <div className="book-a-demo-form-container">
          <HubspotFormEmbed
            params={{
              portalId: "8208398",
              formId: "ded8611c-8865-4206-9f85-a8c58a232aed",
              region: "na1",
            }}
          />
        </div>
      </div>
      <References className="spacing-l" />
      <Quote {...quote} className="spacing-l" />
      <div style={{ textAlign: "center" }}>
        <h6 style={{ fontSize: 18, marginBottom: 8 }}>
          Prefer to skip the demo? Start a free trial!
        </h6>

        <p style={{ marginTop: 0, marginBottom: 8 }}>
          (No credit card required)
        </p>
        <a
          className="label"
          style={{ textDecoration: "underline" }}
          href="https://app.teamspective.com/register"
        >
          Try for free
        </a>
      </div>
    </section>
  )
}

const BookPage = ({ data }) => {
  const { markdownRemark } = data

  return (
    <Layout>
      <BookPageTemplate {...markdownRemark.frontmatter} />
    </Layout>
  )
}

export default BookPage

export const Head = ({ data }) => {
  return (
    <PageHead
      title="Book a demo"
      description={data.markdownRemark.frontmatter.heading}
    />
  )
}

export const BookPageQuery = graphql`
  query BookPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        heading
        pointsTitle
        points {
          description
        }
        solutionsTitle
        solutions
        quote {
          text
          author {
            name
            jobTitle
            company
            profileImage {
              childImageSharp {
                gatsbyImageData(quality: 100, width: 48, height: 48)
              }
            }
          }
          logo {
            publicURL
          }
          logoWidthOverride
        }
      }
    }
  }
`
